@if (selectedShippingOverview) {
  <div class="mt-2 mb-2 opacity-75">
    <b class="d-block text-start">{{type|translate}}</b>
    @for (shippingCost of shippingCosts; track shippingCost) {
      <b>{{shippingCost.shipping_address?.name}} {{shippingCost.shipping_address?.city}}</b>
      @if (shippingCost.shipping_costs?.value && showDetails) {
        <p class="d-block text-start mb-0">{{'MIN_ORDER_AMOUNT_NOSHIPPING'|translate}} <span [innerHTML]="shippingCost.shipping_threshold?.threshold?.value|currencyConvert:shippingCost.shipping_threshold?.threshold?.currency"></span></p>
      }
      @if (shippingCost.shipping_costs?.value && showDetails) {
        <p class="d-block text-start">{{'ACCELL_NL_RESTAMOUNT'|translate}}: <span [innerHTML]="restAmount(shippingCost.shipping_threshold?.threshold?.value)|currencyConvert:shippingCost.shipping_costs?.currency"></span></p>
      }
      <table class="table table-striped mb-0">
        @if (shippingCost.shipping_costs?.value && showDetails) {
          <tr>
            <td class="text-end">{{'SHIPPINGCOST'|translate}}:</td>
            <td class="text-nowrap"
            [innerHTML]="shippingCost.shipping_costs?.value|currencyConvert:shippingCost.shipping_costs?.currency"></td>
          </tr>
        }
        @if (shippingCost.shipping_costs?.value && showDetails) {
          <tr>
            <td class="text-end">{{'SUBTOTAL_BIKE_PARTS'|translate}}:</td>
            <td class="text-nowrap"
            [innerHTML]="total|currencyConvert:shippingCost.shipping_costs?.currency"></td>
          </tr>
        }
        <tr >
          <td class="text-end border-top pe-2">{{'TOTAL'|translate}}:</td>
          <td class="text-nowrap border-top"
          [innerHTML]="grandTotal(shippingCost.shipping_costs?.value, total) |currencyConvert:shippingCost.shipping_costs?.currency"></td>
        </tr>
      </table>
    }
  </div>
}

@if (!selectedShippingOverview) {
  @for (shippingCost of shippingCosts; track shippingCost) {
    <h3>{{shippingCost.shipping_address?.name}} {{shippingCost.shipping_address?.city}}</h3>
    <table class="table table-striped">
      <tr>
        <td>{{'MIN_ORDER_AMOUNT_NOSHIPPING'|translate}}</td>
        <td
          [innerHTML]="shippingCost.minimum_order_amount?.value|currencyConvert:shippingCost.minimum_order_amount?.currency">
        </td>
      </tr>
      <tr>
        <td>{{'SUBTOTAL_BIKE_PARTS'|translate}}</td>
        <td [innerHTML]="shippingCost.ordered_amount?.value|currencyConvert:shippingCost.ordered_amount?.currency"></td>
      </tr>
      <tr>
        <td>{{'ACCELL_NL_RESTAMOUNT'|translate}}</td>
        <td [innerHTML]="shippingCost.to_order_amount?.value|currencyConvert:shippingCost.to_order_amount?.currency">
        </td>
      </tr>
      <tr>
        <td>{{'SHIPPINGCOST'|translate}}</td>
        <td [innerHTML]="shippingCost.shipping_costs?.value|currencyConvert:shippingCost.shipping_costs?.currency"></td>
      </tr>
    </table>
  }
}